import { Err } from '@sniptt/monads';
import { makeSwapErrorRight } from '../../../utils';
import { getTrade } from '../utils/getTrade';
export const getTradeQuote = async (input, deps, relayChainMap) => {
    if (!input.sendAddress) {
        return Err(makeSwapErrorRight({
            message: 'sendAddress is required',
        }));
    }
    if (!input.receiveAddress) {
        return Err(makeSwapErrorRight({
            message: 'receiveAddress is required',
        }));
    }
    const args = {
        buyAsset: input.buyAsset,
        receiveAddress: input.receiveAddress,
        sellAmountIncludingProtocolFeesCryptoBaseUnit: input.sellAmountIncludingProtocolFeesCryptoBaseUnit,
        sellAsset: input.sellAsset,
        sendAddress: input.sendAddress,
        quoteOrRate: 'quote',
        accountNumber: input.accountNumber,
        affiliateBps: input.affiliateBps,
        xpub: 'xpub' in input ? input.xpub : undefined,
    };
    const quotesResult = await getTrade({ input: args, deps, relayChainMap });
    return quotesResult;
};
